import React, { useState, useEffect } from 'react'

// AI 广场 API 在 api.boxiaotu.cn 直连，不用 VITE_API_BASE（是 /cms/api 路径）
const STATS_URL = 'https://api.boxiaotu.cn/api/ai-market/user/stats'
const VIDEOS_URL = '/cms/api/ai-square/videos'

export default function AIMarketUsersPage({ setCurrentPage }) {
  const [stats, setStats] = useState(null)
  const [loading, setLoading] = useState(true)
  const [tab, setTab] = useState('stats') // stats | videos
  const [videos, setVideos] = useState([])
  const [videoTotal, setVideoTotal] = useState(0)
  const [videoPage, setVideoPage] = useState(1)
  const [videoSearch, setVideoSearch] = useState('')
  const [videoType, setVideoType] = useState('')
  const [detailVideo, setDetailVideo] = useState(null)
  const pageSize = 20

  useEffect(() => { loadStats() }, [])

  async function loadStats() {
    setLoading(true)
    try {
      const res = await fetch(STATS_URL, {
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${localStorage.getItem('cms_token') || localStorage.getItem('boxiaotu_token') || ''}` }
      })
      if (res.ok) setStats(await res.json())
    } catch (e) {
      console.error('Load stats error:', e)
    }
    setLoading(false)
  }

  async function loadVideos(p = 1) {
    setLoading(true)
    try {
      const params = new URLSearchParams({ page: p, pageSize })
      if (videoSearch) params.set('search', videoSearch)
      if (videoType) params.set('type', videoType)
      const res = await fetch(`${VIDEOS_URL}?${params}`, {
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${localStorage.getItem('cms_token') || localStorage.getItem('boxiaotu_token') || ''}` }
      })
      if (res.ok) {
        const d = await res.json()
        if (d.success) {
          setVideos(d.data.rows || [])
          setVideoTotal(d.data.total || 0)
          setVideoPage(p)
        }
      }
    } catch (e) { console.error('Load videos error:', e) }
    setLoading(false)
  }

  useEffect(() => { if (tab === 'videos') loadVideos() }, [tab, videoType])

  async function handleDelete(id) {
    if (!confirm('确认删除该视频记录？')) return
    try {
      const res = await fetch(`${VIDEOS_URL}/${id}`, {
        method: 'DELETE',
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${localStorage.getItem('cms_token') || localStorage.getItem('boxiaotu_token') || ''}` }
      })
      const d = await res.json()
      if (d.success) {
        alert('已删除')
        loadVideos(videoPage)
      } else {
        alert('删除失败：' + (d.error || '未知错误'))
      }
    } catch (e) { alert('删除失败: ' + e.message) }
  }

  if (loading && tab === 'stats' && !stats) return <div style={{ padding: 24, color: '#999' }}>加载中...</div>

  return (
    <div style={{ padding: 24 }}>
      {/* Tab 切换 */}
      <div style={{ display: 'flex', gap: 8, marginBottom: 24, borderBottom: '1px solid #eee', paddingBottom: 12 }}>
        {[
          { key: 'stats', label: '📊 用户统计' },
          { key: 'videos', label: '🎬 AI视频记录' },
          { key: 'contacts', label: '📩 客服留言' },
        ].map(t => (
          <div key={t.key} onClick={() => setTab(t.key)}
            style={{
              padding: '8px 20px', borderRadius: '6px 6px 0 0', cursor: 'pointer',
              background: tab === t.key ? '#648CFF' : 'transparent',
              color: tab === t.key ? '#fff' : '#555',
              fontWeight: tab === t.key ? 600 : 400,
              fontSize: 14
            }}>
            {t.label}
          </div>
        ))}
      </div>

      {tab === 'stats' && (
        <div>
          <h2 style={{ marginBottom: 20 }}>👥 AI 广场用户统计</h2>
          {stats ? (
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: 16 }}>
              {[
                { label: '总用户数', value: stats.totalUsers || 0 },
                { label: '今日新增', value: stats.todayNew || 0 },
                { label: '总充值金额', value: '¥' + ((stats.totalRecharge || 0) / 100).toFixed(2) },
                { label: '总消耗金额', value: '¥' + ((stats.totalSpent || 0) / 100).toFixed(2) },
                { label: '视频总数', value: stats.totalVideos || 0 },
                { label: '今日视频', value: stats.todayVideos || 0 },
                { label: '留言总数', value: stats.totalContacts || 0, link: 'cs-contacts' },
                { label: '待处理留言', value: stats.pendingContacts || 0, link: 'cs-contacts', highlight: (stats.pendingContacts || 0) > 0 },
              ].map(item => (
                <div key={item.label} onClick={() => item.link && setCurrentPage && setCurrentPage(item.link)} style={{
                  background: '#fff', borderRadius: 12, padding: 20,
                  border: item.highlight ? '2px solid #e94560' : '1px solid #eee',
                  textAlign: 'center',
                  cursor: item.link ? 'pointer' : 'default',
                  transition: 'box-shadow 0.2s',
                }}
                onMouseEnter={e => { if (item.link) e.currentTarget.style.boxShadow = '0 2px 12px rgba(233,69,96,.2)' }}
                onMouseLeave={e => { if (item.link) e.currentTarget.style.boxShadow = 'none' }}
                >
                  <div style={{ fontSize: 28, fontWeight: 700, color: item.highlight ? '#e94560' : '#333', marginBottom: 4 }}>{item.value}</div>
                  <div style={{ fontSize: 13, color: '#888' }}>
                    {item.label}
                    {item.link && <span style={{ marginLeft: 4, fontSize: 10 }}>→</span>}
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <p style={{ color: '#999' }}>暂无数据，请确保后端 API 已配置</p>
          )}
        </div>
      )}

      {tab === 'videos' && (
        <div>
          <h2 style={{ marginBottom: 20 }}>🎬 AI视频记录 <span style={{ fontSize: 14, color: '#999', fontWeight: 400 }}>（共 {videoTotal} 条）</span></h2>

          {/* 搜索和筛选 */}
          <div style={{ display: 'flex', gap: 12, marginBottom: 20, alignItems: 'center' }}>
            <input
              value={videoSearch}
              onChange={e => setVideoSearch(e.target.value)}
              onKeyDown={e => e.key === 'Enter' && loadVideos(1)}
              placeholder="搜索标题/描述..."
              style={{ padding: '8px 14px', border: '1px solid #d9d9d9', borderRadius: 6, width: 240, fontSize: 13 }}
            />
            <select
              value={videoType}
              onChange={e => setVideoType(e.target.value)}
              style={{ padding: '8px 14px', border: '1px solid #d9d9d9', borderRadius: 6, fontSize: 13 }}
            >
              <option value="">全部类型</option>
              <option value="basic">basic（基础）</option>
              <option value="standard">standard（标准）</option>
            </select>
            <button onClick={() => loadVideos(1)}
              style={{ padding: '8px 20px', background: '#1890ff', color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer', fontSize: 13 }}>
              搜索
            </button>
          </div>

          {/* 视频表格 */}
          {loading ? (
            <div style={{ color: '#999', padding: 40, textAlign: 'center' }}>加载中...</div>
          ) : videos.length === 0 ? (
            <div style={{ color: '#999', padding: 40, textAlign: 'center' }}>暂无视频记录</div>
          ) : (
            <div style={{ overflowX: 'auto' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse', background: '#fff', borderRadius: 8, overflow: 'hidden' }}>
                <thead>
                  <tr style={{ background: '#fafafa', borderBottom: '2px solid #eee' }}>
                    <th style={thStyle}>ID</th>
                    <th style={thStyle}>手机号</th>
                    <th style={thStyle}>联系人</th>
                    <th style={thStyle}>公司</th>
                    <th style={thStyle}>标题</th>
                    <th style={{ ...thStyle, maxWidth: 300 }}>描述</th>
                    <th style={thStyle}>类型</th>
                    <th style={thStyle}>费用(分)</th>
                    <th style={thStyle}>创建时间</th>
                    <th style={thStyle}>状态</th>
                    <th style={{ ...thStyle, width: 180 }}>操作</th>
                  </tr>
                </thead>
                <tbody>
                  {videos.map(v => (
                    <tr key={v.id} style={{ borderBottom: '1px solid #f0f0f0', '&:hover': { background: '#fafafa' } }}>
                      <td style={tdStyle}>{v.id}</td>
                      <td style={tdStyle}>{v.phone || '-'}</td>
                      <td style={tdStyle}>{v.contact_name || '-'}</td>
                      <td style={{ ...tdStyle, maxWidth: 160, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{v.company_name || '-'}</td>
                      <td style={{ ...tdStyle, fontWeight: 500 }}>{v.title || '-'}</td>
                      <td style={{ ...tdStyle, maxWidth: 300, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                        {v.description || '-'}
                      </td>
                      <td style={tdStyle}>
                        <span style={{
                          padding: '2px 8px', borderRadius: 4, fontSize: 12,
                          background: v.video_type === 'standard' ? '#e6f7ff' : '#fff7e6',
                          color: v.video_type === 'standard' ? '#1890ff' : '#fa8c16'
                        }}>{v.video_type}</span>
                      </td>
                      <td style={tdStyle}>{(v.cost_cents || 0) > 0 ? `${v.cost_cents} 分` : '-'}</td>
                      <td style={{ ...tdStyle, fontSize: 12, color: '#999' }}>{v.created_at?.slice(0, 16) || '-'}</td>
                      <td style={tdStyle}>
                        <span style={{
                          padding: '2px 8px', borderRadius: 4, fontSize: 12,
                          background: v.status === 'completed' ? '#f6ffed' : '#fff2f0',
                          color: v.status === 'completed' ? '#52c41a' : '#ff4d4f'
                        }}>{v.status || '-'}</span>
                      </td>
                      <td style={tdStyle}>
                        <div style={{ display: 'flex', gap: 8 }}>
                          <button onClick={() => setDetailVideo(v)}
                            style={btnStyle('#1890ff')}>查看</button>
                          {v.video_url && (
                            <a href={v.video_url} target="_blank" rel="noopener noreferrer"
                              style={{ ...btnStyle('#52c41a'), textDecoration: 'none', display: 'inline-block' }}>播放</a>
                          )}
                          <button onClick={() => handleDelete(v.id)}
                            style={btnStyle('#ff4d4f')}>删除</button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

          {/* 分页 */}
          {videoTotal > pageSize && (
            <div style={{ display: 'flex', justifyContent: 'center', gap: 8, marginTop: 20 }}>
              <button onClick={() => loadVideos(videoPage - 1)} disabled={videoPage <= 1}
                style={{ padding: '6px 14px', border: '1px solid #d9d9d9', borderRadius: 4, background: '#fff', cursor: videoPage <= 1 ? 'default' : 'pointer', opacity: videoPage <= 1 ? 0.5 : 1 }}>上一页</button>
              <span style={{ padding: '6px 12px', fontSize: 13, color: '#666' }}>第 {videoPage} / {Math.ceil(videoTotal / pageSize)} 页</span>
              <button onClick={() => loadVideos(videoPage + 1)} disabled={videoPage >= Math.ceil(videoTotal / pageSize)}
                style={{ padding: '6px 14px', border: '1px solid #d9d9d9', borderRadius: 4, background: '#fff', cursor: videoPage >= Math.ceil(videoTotal / pageSize) ? 'default' : 'pointer', opacity: videoPage >= Math.ceil(videoTotal / pageSize) ? 0.5 : 1 }}>下一页</button>
            </div>
          )}
        </div>
      )}

      
      {tab === 'contacts' && (
        <ContactsTab />
      )}

      {/* 详情 Modal */}
      {detailVideo && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}
          onClick={() => setDetailVideo(null)}>
          <div onClick={e => e.stopPropagation()} style={{ background: '#fff', borderRadius: 12, padding: 24, width: 560, maxHeight: '80vh', overflow: 'auto' }}>
            <h3 style={{ margin: '0 0 16px' }}>视频详情 #{detailVideo.id}</h3>
            {[
              ['标题', detailVideo.title],
              ['描述', detailVideo.description],
              ['手机号', detailVideo.phone],
              ['联系人', detailVideo.contact_name],
              ['公司', detailVideo.company_name],
              ['类型', detailVideo.video_type],
              ['费用(分)', detailVideo.cost_cents],
              ['时长(秒)', detailVideo.duration],
              ['状态', detailVideo.status],
              ['tier', detailVideo.tier],
              ['用户ID', detailVideo.user_id],
              ['创建时间', detailVideo.created_at],
            ].map(([label, value]) => (
              <div key={label} style={{ marginBottom: 10, display: 'flex' }}>
                <span style={{ width: 100, color: '#999', flexShrink: 0 }}>{label}:</span>
                <span style={{ wordBreak: 'break-all' }}>{value || '-'}</span>
              </div>
            ))}
            {detailVideo.video_url && (
              <div style={{ marginTop: 12 }}>
                <video src={detailVideo.video_url} controls style={{ width: '100%', borderRadius: 8, maxHeight: 300 }} />
              </div>
            )}
            <div style={{ marginTop: 16, textAlign: 'right' }}>
              <button onClick={() => setDetailVideo(null)}
                style={{ padding: '8px 24px', border: '1px solid #d9d9d9', borderRadius: 6, background: '#fff', cursor: 'pointer' }}>关闭</button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

  // 客服留言子组件
  const ContactsTab = () => {
    const [list, setList] = useState([])
    const [cTotal, setCTotal] = useState(0)
    const [cPage, setCPage] = useState(1)
    const [cStatus, setCStatus] = useState('')
    const [replyId, setReplyId] = useState(null)
    const [replyText, setReplyText] = useState('')
    const [loading, setLoading] = useState(true)

    useEffect(() => { setLoading(true); loadContacts(1) }, [cStatus]);

    async function loadContacts(p) {
      try {
        const params = new URLSearchParams({ page: p, limit: 20 })
        if (cStatus) params.set('status', cStatus)
        const res = await fetch(`/cms/api/cs-contacts?${params}`)
        if (res.ok) {
          const d = await res.json()
          if (d.ok) { setList(d.data || []); setCTotal(d.total || 0); setCPage(p) }
        }
      } catch(e) { console.error(e) }
      setLoading(false)
    }

    async function handleReply(id) {
      if (!replyText.trim()) { alert('请输入回复内容'); return }
      try {
        const res = await fetch(`/cms/api/cs-contacts/${id}`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ status: 'replied', reply: replyText })
        })
        const d = await res.json()
        if (d.ok) { alert('回复成功'); setReplyId(null); setReplyText(''); loadContacts(cPage) }
        else alert(d.error || '回复失败')
      } catch(e) { alert('回复失败: ' + e.message) }
    }

    return (
      <div>
        <h2 style={{ marginBottom: 20 }}>📩 客服留言 <span style={{ fontSize: 14, color: '#999', fontWeight: 400 }}>（共 {cTotal} 条）</span></h2>

        <div style={{ display: 'flex', gap: 12, marginBottom: 20 }}>
          <select value={cStatus} onChange={e => setCStatus(e.target.value)}
            style={{ padding: '8px 14px', border: '1px solid #d9d9d9', borderRadius: 6, fontSize: 13 }}>
            <option value="">全部状态</option>
            <option value="pending">待处理</option>
            <option value="replied">已回复</option>
          </select>
        </div>

        {loading ? <div style={{ color: '#999', padding: 40, textAlign: 'center' }}>加载中...</div>
        : list.length === 0 ? <div style={{ color: '#999', padding: 40, textAlign: 'center' }}>暂无留言</div>
        : (
          <div>
            {list.map(item => (
              <div key={item.id} style={{
                background: '#fff', borderRadius: 8, padding: 16, marginBottom: 12,
                border: '1px solid #eee',
                borderLeft: item.status === 'new' || item.status === 'pending' ? '4px solid #fa8c16' : '4px solid #52c41a'
              }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
                  <div>
                    <b style={{ marginRight: 12 }}>{item.nickname || '匿名'}</b>
                    <span style={{ color: '#999', fontSize: 13 }}>{item.phone || '-'}</span>
                    <span style={{
                      marginLeft: 8, padding: '2px 8px', borderRadius: 4, fontSize: 12,
                      background: item.status === 'new' || item.status === 'pending' ? '#fff7e6' : '#f6ffed',
                      color: item.status === 'new' || item.status === 'pending' ? '#fa8c16' : '#52c41a'
                    }}>{item.status === 'new' || item.status === 'pending' ? '待处理' : '已回复'}</span>
                  </div>
                  <span style={{ color: '#999', fontSize: 12 }}>{item.created_at?.slice(0, 16)}</span>
                </div>
                <div style={{ background: '#f9f9f9', borderRadius: 6, padding: 12, marginBottom: 8, whiteSpace: 'pre-wrap', fontSize: 14 }}>
                  {item.content}
                </div>
                {item.reply ? (
                  <div style={{ background: '#e6f7ff', borderRadius: 6, padding: 12, fontSize: 14, borderLeft: '3px solid #1890ff' }}>
                    <div style={{ color: '#999', fontSize: 12, marginBottom: 4 }}>💬 回复：</div>
                    {item.reply}
                  </div>
                ) : (
                  replyId === item.id ? (
                    <div style={{ marginTop: 8 }}>
                      <textarea value={replyText} onChange={e => setReplyText(e.target.value)}
                        placeholder="输入回复内容..."
                        style={{ width: '100%', padding: 10, border: '1px solid #d9d9d9', borderRadius: 6, fontSize: 13, resize: 'vertical', minHeight: 80 }} />
                      <div style={{ display: 'flex', gap: 8, marginTop: 8 }}>
                        <button onClick={() => handleReply(item.id)}
                          style={{ padding: '6px 16px', background: '#1890ff', color: '#fff', border: 'none', borderRadius: 4, cursor: 'pointer', fontSize: 13 }}>发送回复</button>
                        <button onClick={() => { setReplyId(null); setReplyText('') }}
                          style={{ padding: '6px 16px', border: '1px solid #d9d9d9', borderRadius: 4, background: '#fff', cursor: 'pointer', fontSize: 13 }}>取消</button>
                      </div>
                    </div>
                  ) : (
                    <button onClick={() => { setReplyId(item.id); setReplyText('') }}
                      style={{ padding: '4px 12px', border: '1px solid #1890ff', borderRadius: 4, background: '#fff', color: '#1890ff', cursor: 'pointer', fontSize: 12 }}>回复</button>
                  )
                )}
              </div>
            ))}
          </div>
        )}

        {cTotal > 20 && (
          <div style={{ display: 'flex', justifyContent: 'center', gap: 8, marginTop: 20 }}>
            <button onClick={() => loadContacts(cPage - 1)} disabled={cPage <= 1}
              style={{ padding: '6px 14px', border: '1px solid #d9d9d9', borderRadius: 4, background: '#fff', cursor: cPage <= 1 ? 'default' : 'pointer', opacity: cPage <= 1 ? 0.5 : 1 }}>上一页</button>
            <span style={{ padding: '6px 12px', fontSize: 13, color: '#666' }}>第 {cPage} / {Math.ceil(cTotal / 20)} 页</span>
            <button onClick={() => loadContacts(cPage + 1)} disabled={cPage >= Math.ceil(cTotal / 20)}
              style={{ padding: '6px 14px', border: '1px solid #d9d9d9', borderRadius: 4, background: '#fff', cursor: cPage >= Math.ceil(cTotal / 20) ? 'default' : 'pointer', opacity: cPage >= Math.ceil(cTotal / 20) ? 0.5 : 1 }}>下一页</button>
          </div>
        )}
      </div>
    )
  }

const thStyle = { padding: '10px 12px', textAlign: 'left', color: '#666', fontWeight: 600, fontSize: 13, whiteSpace: 'nowrap' }
const tdStyle = { padding: '10px 12px', fontSize: 13, color: '#333' }
const btnStyle = (color) => ({
  padding: '4px 12px', border: '1px solid ' + color, borderRadius: 4,
  background: '#fff', color: color, cursor: 'pointer', fontSize: 12
})
